import styled from "styled-components"
import { BaseStyle } from "../common"

const Cards = styled.div`
  ${BaseStyle}
  justify-content: center;
  max-width: 690px;
  flex-shrink: 1;
`

export { Cards as default }


// WEBPACK FOOTER //
// ./assets/common/components/ProfileCards/components/Cards.js